import React from 'react';
import Separator from '../../../../core/layout/Separator';
import Card from '../../../../core/layout/Card';
import Column from '../../../../core/layout/Column';
import Row from '../../../../core/layout/Row';
import StudentAccessFrequencyGaugeContainer from './student/StudentAccessFrequencyGaugeContainer';
import StudentEngagementGaugeContainer from './student/StudentEngagementGaugeContainer';
import StudentChurnGaugeContainer from './student/StudentChurnGaugeContainer';
import StudentStudyQualityGaugeContainer from './student/StudentStudyQualityGaugeContainer';
import PartnerLicensePackageUsageRateGaugeContainer from './partner/PartnerLicensePackageUsageRateGaugeContainer';
import PartnerStudentVariationGaugeContainer from './partner/PartnerStudentVariationGaugeContainer';
import PartnerAccessFrequencyGaugeContainer from './partner/PartnerAccessFrequencyGaugeContainer';
import CustomerSuccessHistoryDialogContainer from './CustomerSuccessHistoryDialogContainer';

const CustomerSuccessGlobalTab = () => (
  <div>
    <Card title="Partners">
      <Row>
        <Column size={4}>
          <PartnerAccessFrequencyGaugeContainer />
        </Column>
        <Column size={4}>
          <PartnerLicensePackageUsageRateGaugeContainer />
        </Column>
        <Column size={4}>
          <PartnerStudentVariationGaugeContainer />
        </Column>
      </Row>
    </Card>
    <Separator />
    <Card title="Students">
      <Row>
        <Column size={3}>
          <StudentAccessFrequencyGaugeContainer />
        </Column>
        <Column size={3}>
          <StudentEngagementGaugeContainer />
        </Column>
        <Column size={3}>
          <StudentChurnGaugeContainer />
        </Column>
        <Column size={3}>
          <StudentStudyQualityGaugeContainer />
        </Column>
      </Row>
    </Card>
    <CustomerSuccessHistoryDialogContainer />
  </div>
);

export default CustomerSuccessGlobalTab;
